<template>
    <div class="newSearch">
        <div>
            <img src="../assets/banner/新闻中心banner1920x280px.png">
        </div>
    
        <div class="container margin-auto margin-top-30">
            
            <div style="min-height:600px;" v-if="list.length>0">
                <newsList :list="list"/>
                <div class="flex justify-center margin-top">
                    <el-pagination
                        :current-page.sync="page" 
                        :page-size="5"
                        @current-change="currentChange"
                        background
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <div style="min-height:600px;" v-else>
                <div class="text-gray" style="text-algin:center;">
                    暂无相关“{{keyword}}”的内容……
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import newsList from '../components/news/newsList'
    import {getNews} from '../api/api'
    export default {
        name: 'NewsSearch',
        components:{
            newsList
        },
        data() {
            return {
                keyword:'',
                list:[],
                page:1,
                total:0

            }
        },
        watch:{

            '$route':'getKeyword'
        },
        methods:{
            getKeyword(){
                this.keyword=this.$route.query.keyword
                this.getNews(1)
            },
            currentChange(e){
                // console.log(e)
                this.getNews(e)
            },
            getNews(page){
                let data={
                    keyword:this.keyword,
                    page:page,
                    limit:5
                }
                getNews(data).then(res=>{
                    if(res.code==1){
                        this.list=res.data
                        this.total=res.count
                    }
                })
            },
        },
        created(){
            this.keyword=this.$route.query.keyword
            this.getNews(1)
        }
    }
</script>

<style lang="scss">
  .newSearch .newsItemsBox .newsItems{
      width: 100%;
  } 
</style>